import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css'
import Form from './components/RegistrationForm'
import registerServiceWorker from './registerServiceWorker';
import * as firebase from 'firebase'
import {BrowserRouter, Route, Switch } from 'react-router-dom'
import Home from './components/Home_Page'

// This React App can use Firebase and is deployed to Firebase Hositng for testing   https://agfc-bow.firebaseapp.com
 // Initialize Firebase
var config = {
    apiKey: "AIzaSyCDfpCb8s1M9EDrwm_xO_GdgPUkKIiQHRM",
    authDomain: "agfc-bow.firebaseapp.com",
    databaseURL: "https://agfc-bow.firebaseio.com",
    projectId: "agfc-bow",
    storageBucket: "agfc-bow.appspot.com",
    messagingSenderId: "361426324175"
  };
  firebase.initializeApp(config);




ReactDOM.render(
    <BrowserRouter>
        <Switch>
            <Route path="/bow/registration" component={Form}/>
            <Route path="/" component={Home}/>
        </Switch>
    </BrowserRouter>



, document.getElementById('form'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js